// @ts-expect-error pure js
import useCourriers from "../../../hooks/use-courriers";
import CardCourrier from "../../Courrier/CardCourrier";
// @ts-expect-error pure js
import { FileIcon } from "../../UI/Icons";
// @ts-expect-error pure js
import IconAndText from "../../UI/IconAndText";
import Text from "../../UI/Text";
import type { Courrier } from "../../../models/courrier";
import styles from "./SelectCourrier.module.css";

const CATEGORY_PROMPTS: Record<string, string> = {
  information: "Vous souhaitez envoyer une information ?",
  impaye: "Vous faites face à un impayé ?",
  trouble: "Vous faites face à des troubles de voisinage ?",
  justificatif: "Vous souhaitez demander un justificatif ?",
  meuble: "S'il s'agit d'un bail meublé",
  nu: "S'il s'agit d'un bail nu",
  montant: "Vous souhaitez modifier le montant du loyer ou des charges ?",
};

interface SelectCourrierProps {
  type: string;
  onSelectCourrier: (staticId: string) => void;
  massOnly?: boolean;
}

export default function SelectCourrier({
  type,
  onSelectCourrier,
  massOnly = false,
}: SelectCourrierProps) {
  const { courriers: allCourriers }: { courriers: Courrier[] } =
    useCourriers(type);
  const courriers = massOnly
    ? allCourriers.filter((courrier) => courrier.is_mass)
    : allCourriers;
  const uniqueCategories = [
    ...new Set(courriers.map((courrier) => courrier.category)),
  ];

  return (
    <div className={styles.categories}>
      {uniqueCategories.map((category) => (
        <div key={category} className={styles.category}>
          <IconAndText
            icon={<FileIcon />}
            text={
              <Text>{CATEGORY_PROMPTS[category] ?? "Autres documents"}</Text>
            }
          />
          <div className={styles.separator} />
          <CardCourrier
            onSelectCourrier={onSelectCourrier}
            courriers={courriers.filter(
              (courrier) => courrier.category === category,
            )}
          />
        </div>
      ))}
    </div>
  );
}
